import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, XIcon, CheckIcon, LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { PremiumUpsellCTA, CHECKOUT_KIT } from './PremiumUpsellCTA';
const cantAvoid = ['la presión;', 'los pendientes;', 'las conversaciones incómodas;', 'las personas difíciles;', 'los cambios;', 'o los días complicados.'];
const canDo = ['bajar la tensión', 'recuperar el foco', 'poner límites', 'responder con claridad', 'manejar conversaciones difíciles', 'y desconectar cuando el día termina.'];
export function FinalCTA() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-27" data-mp="vu8ab2gcib00">
      <div className="max-w-3xl mx-auto" data-id="element-28" data-mp="qvezxiwcv042">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-29" data-mp="qwgjkbrfsuxe">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-30" data-mp="2h2y5n518c3qr">
            Tu trabajo ocupa muchas horas de tu vida.
          </h2>
          <p className="font-serif-italic text-rose text-xl md:text-2xl mt-4" data-id="element-31" data-mp="2r2786ma5uqoq">
            No necesita ocupar también toda tu cabeza.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5 mb-14" data-id="element-32" data-mp="302lvfr6oqfuv">
          <div className="bg-white border border-line rounded-3xl p-6 md:p-7 shadow-sm" data-id="element-33" data-mp="30110i0ggkuwh">
            <div className="text-xs font-bold text-muted tracking-widest mb-4" data-id="element-34" data-mp="34un30zswriek">
              NO SIEMPRE PODÉS EVITAR
            </div>
            <ul className="space-y-2.5" data-id="element-35" data-mp="39uhxfdbw6q4d">
              {cantAvoid.map((c, i) => <li key={i} className="flex items-start gap-3" data-id="element-36" data-mp="3etclousmp6vv" data-mpi={i}>
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-rose/10 flex items-center justify-center mt-0.5" data-id="element-37" data-mp="3iu4x9uoz3nvb">
                    <XIcon className="w-3 h-3 text-rose" strokeWidth={3} data-id="element-38" data-mp="1jov19uiv8edy" />
                  </span>
                  <span className="text-ink text-sm" data-id="element-39" data-mp="1eqtmvmwdx38t">{c}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-white border border-rose/30 rounded-3xl p-6 md:p-7 shadow-sm" data-id="element-40" data-mp="1sihy7nyt7noq">
            <div className="text-xs font-bold text-rose tracking-widest mb-4" data-id="element-41" data-mp="1no3w72pn6ib3">
              PERO SÍ PODÉS DESARROLLAR HERRAMIENTAS PARA
            </div>
            <ul className="space-y-2.5" data-id="element-42" data-mp="1xeou0nxhrisy">
              {canDo.map((c, i) => <li key={i} className="flex items-start gap-3" data-id="element-43" data-mp="2bg14wkxsou7z" data-mpi={i}>
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-rose/15 flex items-center justify-center mt-0.5" data-id="element-44" data-mp="2bd6m0xufjhgo">
                    <CheckIcon className="w-3 h-3 text-rose" strokeWidth={3} data-id="element-45" data-mp="h18h3835l7ql" />
                  </span>
                  <span className="text-ink text-sm" data-id="element-46" data-mp="d0epa3mlb8sf">{c}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="text-center font-serif-italic text-rose text-xl md:text-2xl mb-14" data-id="element-47" data-mp="2whqypuume24">
          Trabajar mejor también significa aprender a cuidarte mientras
          trabajás.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-rose/30 rounded-3xl p-7 md:p-10 shadow-2xl shadow-rose/10 text-center" data-id="element-48" data-mp="3pb16ipvk7za6">
          <div className="flex justify-center mb-5" data-id="element-49" data-mp="3bbrrhtj3bb7s">
            <img src="https://cdn.magicpatterns.com/uploads/vvwFq218QqEK4oqinbrNgQ/imagen_principal.png" alt="Kit Antiestrés para el Trabajo — 4 materiales digitales" className="h-44 md:h-56 w-auto object-contain drop-shadow-xl" data-id="element-50" data-mp="3bckqu9fpyyfw" />
          </div>
          <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink uppercase tracking-tight leading-tight" data-id="element-51" data-mp="35m8e4vdwqvzx">
            Kit Antiestrés para el Trabajo
          </h3>
          <p className="font-serif-italic text-rose text-lg mt-2" data-id="element-52" data-mp="2voluxwpksia5">
            4 materiales + 2 premium · +60 páginas prácticas
          </p>
          <div className="text-muted text-[14px] mt-6" data-id="element-53" data-mp="2rnignen6eub1">
            Valor individual: <span className="line-through" data-id="element-54" data-mp="2mpgwsrhxeqyi">$39.990</span>
          </div>
          <div className="flex items-baseline justify-center gap-2 flex-wrap mt-1" data-id="element-55" data-mp="2hxgoaansipqb">
            <span className="font-serif font-bold text-5xl md:text-6xl text-rose" data-id="element-56" data-mp="2cym9djsy1lbh">
              $19.990
            </span>
            <span className="text-lg text-ink-soft" data-id="element-57" data-mp="280kgk75pu7mt">ARS</span>
          </div>
          <div className="inline-flex items-center gap-2 bg-rose text-white text-xs font-black px-3 py-1 rounded-full mt-3" data-id="element-58" data-mp="23xxsmhc616uw">
            50% OFF
          </div>
          <div className="text-sm text-muted mt-2 mb-7" data-id="element-59" data-mp="1yzw9jweqp7jf">
            Pago único · Acceso de por vida
          </div>

          <a href={CHECKOUT_KIT} target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout');
          }
        }} className="flex items-center justify-center gap-2 w-full bg-rose hover:bg-rose-deep text-white font-bold text-lg md:text-xl py-5 rounded-full text-center shadow-xl shadow-rose/30 hover:-translate-y-0.5 transition-all" data-id="element-60" data-mp="ejenoshywpd2">
            <ArrowRightIcon className="w-5 h-5" data-id="element-61" data-mp="4qh2gellcmar" />
            QUIERO ACCEDER AL KIT
          </a>

          <PremiumUpsellCTA data-id="element-62" data-mp="9j0olzycgpr6" />

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-6 text-xs text-muted" data-id="element-63" data-mp="9k23kfihdwe6">
            <span className="flex items-center gap-1.5" data-id="element-64" data-mp="3864xxw45r9ip">
              <LockIcon className="w-3.5 h-3.5 text-rose" data-id="element-65" data-mp="3d5rcc8vq2vt3" /> Pago seguro
            </span>
            <span className="text-line" data-id="element-66" data-mp="kbk4s7a7hjrj">|</span>
            <span className="flex items-center gap-1.5" data-id="element-67" data-mp="ka8zg31443yb">
              <ZapIcon className="w-3.5 h-3.5 text-rose" data-id="element-68" data-mp="fcplz5c8nv7f" /> Acceso en 5 min
            </span>
            <span className="text-line" data-id="element-69" data-mp="t3ufdpp0jr9b">|</span>
            <span className="flex items-center gap-1.5" data-id="element-70" data-mp="t6qbr9l7q7vn">
              <ShieldCheckIcon className="w-3.5 h-3.5 text-rose" data-id="element-71" data-mp="p4lk2gebrlbn" /> Garantía 7
              días
            </span>
            <span className="text-line" data-id="element-72" data-mp="1dzpnrx8tzk4">|</span>
            <span className="flex items-center gap-1.5" data-id="element-73" data-mp="3skamtcz4ug66">
              <CreditCardIcon className="w-3.5 h-3.5 text-rose" data-id="element-74" data-mp="3slvi54t9u353" /> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}